export default {
  vehiclesType: {
    CUSTOM: 'Custom',
    AIRPLANE: 'Airplane',
    CAR: 'Car',
    TRAIN: 'Train',
    HIGH_SPEED_TRAIN: 'High speed train',
  },
  tourType: {
    DOMESTIC: 'Domestic',
    OUTBOUND: 'Outbound',
  },
  msg: {
    selectedTourNotFound: 'Please select tour again!',
    agencyPlaceholder: 'Select agency for book tour',
  },
  field: {
    contactName: 'Fullname',
    contactPhone: 'Phone Number',
    email: 'Email',
    address: 'Address',
    type: 'Loại khách',
    unitPrice: 'Price/person',
    commission: 'Commission',
    totalCommission: 'Total Commission',
    number: 'Number',
    totalAmount: 'Total Amount',
    chooseAgency: 'Select agency',
    agency: 'Agency',
    totalSingleRoom: 'Total single room',
  },
  ph: {
    contactName: 'Enter fullname',
    contactPhone: 'Enter phone number',
    email: 'Enter email',
    address: 'Enter address',
  },
  passenger: {
    Adults: 'Adult',
    Children1: 'Children 1',
    Children2: 'Children 2',
    Infant: 'Infant',
    ageFrom: 'From {ageFrom} yo above',
    ageBetween: 'From {ageFrom}-{ageTo} yo',
    ageTo: 'Below {ageTo} yo',
  },
  totalPrice: 'Total price',
  displaySettings: 'Display',
  tableColumns: {
    no: 'No.', // No.
    bookingCode: 'Booking code', // Booking code
    status: 'Status', // Status
    customerName: 'Customer name', // Customer name
    tourName: 'Tour name', // Tour name
    startDate: 'Start date', // Start date
    totalPrice: 'Total price', // Total price
    totalCommission: 'Total commission', // Total commission
    createdAt: 'Created at', // Created at
    createdBy: 'Created by', // Created by
    note: 'Note', // Note
    actions: 'Actions', // Actions
    totalPriceToBePaid: 'Total price need to pay',
    totalPriceRefund: 'Total refund',
    depositPrice: 'Deposited / Paid',

    paxType: 'Pax type',
    tourPrice: 'Tour price',
    paxQuantity: 'Quantity',
    // totalPrice: 'Total price',
  },
  status: {
    pendingPayment: 'Pending Payment',
    done: 'Completed',
    canceled: 'Canceled',
    confirming: 'Awaiting Confirmation',
    ALL: 'ALL',
    RESERVED: 'Reserved', // Giữ chỗ
    DEPOSITED: 'Deposited', // Đã đặt cọc
    REQUEST_DEPOSIT: 'Request Deposit',
    REQUEST_PAYMENT: 'Request Payment',
    REQUEST_UPDATE: 'Request Update',
    PAID: 'Paid', // Đã thanh toán
    CANCELLATION_REQUESTED: 'Cancellation Requested', // Yêu cầu huỷ
    CANCELLED: 'Cancelled', // Đã huỷ
    EXPIRED: 'Expired',
  },
  showCommission: 'Show commission',
  hideCommission: 'Hide commission',
  bookingDetail: {
    tourInfo: 'Tour information',
    contactInfo: 'Contact information',
    paymentDeadline: 'Payment deadline',
    timeHold: 'Time hold',
  },
  historyActions: {
    CREATE: 'Book tour',
    CONFIRM_PAYMENT: 'Confirmed deposit/payment',
    CONFIRM_UPDATE: 'Confirmed update',
    REQUEST_CANCEL: 'Request cancel tour',
    REQUEST_SUPPORT: 'Confirm tour',
  },
  startDate: 'Start Date',
  endDate: 'End Date',
  bankAcc: 'Receiving Bank Account',
  placeholderSelectDate: 'Select date',
  placeholderSearch: 'Search by payment ID, sender name, or bank name',
  moreDropdownTitle: '',

  currency: 'VND',
  detail: 'Top-up Details',
  tabInfo: 'Top-up Information',
  confirm: 'Confirm',
  confirmManual: 'Confirm Manual Top-up',
  delete: 'Delete',
  errFetchData_1: 'Error fetching top-up data',
  errFetchData_2: 'No top-up found with this customer ID. Please check',
  errFetchData_3: 'another top-up.',

  createTopup: 'Create Top-up Order',
  createTopupForChild: 'Create Top-up Order for Sub-agency',
  tooltip: {
    allowTopup: 'Only agents with signed contracts can create top-up orders. Please contact your Booker for support',
  },
  btn: {
    requestSupport: 'Confirm Tour',
    requestedSupport: 'Confirmed Tour',
  },
  suggestedTours: 'Suggested Tours',
  duration: 'Duration',
  durationWith: '{totalDay} Days {totalNight} Nights',
  SearchingSuitableTourPackages: 'We are searching for suitable tour packages for you.',
  noTourSuggestionsReferAvailableTours: 'No tour suggestions are available for this booking. Please refer to other available tours',
  here: 'here',
  detailView: 'View detail',
  titleRepicient: 'Top-up Request',
  titleSender: 'Top-up',
  management: 'Top-up Management',
  list: 'Top-up List',
  paymentStatus: 'Payment Status',
  amount: 'Amount',
  paymentAmount: 'Payment Amount',
  senderId: 'Sender ID',
  senderName: 'Sender',
  entity: 'Role',
  senderEntity: 'Sender role',
  recipientId: 'Recipient ID',
  recipientEntity: 'Recipient role',
  bankAccountName: 'Bank account name',
  bankAccountNo: 'Bank account number',
  note: 'Note',
  evidence: 'Evidence',
  uploadEvidence: 'Upload evidence image',
  placeholderChooseImage: 'Choose an image or drop it here...',
  placeholderDropImage: 'Drop the image here...',
  evidenceUrl: 'Top-up evidence document',
  bankCode: 'Bank code',

  confirmAutoPayment: 'Automatically issue tickets based on the order',
  at: 'at',
  sender: 'Top-up agent',
  recipient: 'Receiving agent',
  placeholderSender: 'Please select a top-up agent',
  pleaseTopupMinAmount: 'Please top up at least {minAmount} VND',
  topupInfo: 'Top-up information',
  parentAgencyNotHaveBankAccount: 'The parent agency has not set up a receiving bank account. Please contact the parent agency.',
  createQrSuccess: 'Top-up order created successfully. Please scan the QR code to top up.',
  history: 'Top-up history',
  viewDetails: 'View details',
  noHistoryRecord: 'No top-up history found',
}
